<template>
    <component :is="tag">
        <slot
            :brief="brief"
            :step="step"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-step="patchStep"
            :isLoading="isLoading"
            :is-completing-brief="isCompletingBrief"
            :is-patching-brief="isPatchingBrief"
            :errors="errors"
            :errorMessage="errorMessage"
        />
    </component>
</template>

<script>
    import {NAME_PRODUCTS} from '../../../constants/activation-brief-steps';
    import BaseActivationBriefStepMixin from '../mixins/BaseActivationBriefStepMixin';

    export default {
        name:   'ActivationBriefProductsProvider',
        mixins: [
            BaseActivationBriefStepMixin,
        ],
        computed: {
            step(){
                return this.steps[NAME_PRODUCTS];
            },
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadActivationBrief(),
                    ]);
                })
                .then(() => {
                    this.initStep(this.step);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        },
    };
</script>
